import React from 'react';
import { motion } from 'framer-motion';
import { useCountdown } from './useCountdown';
import { Clock, AlertTriangle } from 'lucide-react';
export function CountdownScarcity() {
  // 23h 27m 35s in seconds = 84455
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(84455);
  return <section className="py-16 px-4 bg-white border-b border-stone-200" data-id="element-86">
      <div className="max-w-3xl mx-auto text-center" data-id="element-87">
        <div className="flex items-center justify-center gap-2 text-red-600 font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-88">
          <Clock className="w-5 h-5" data-id="element-89" />
          <h2 data-id="element-90">PRECIO DE LANZAMIENTO — CIERRA EN:</h2>
        </div>

        <div className="flex justify-center gap-4 mb-6" data-id="element-91">
          <div className="flex flex-col items-center" data-id="element-92">
            <div className="bg-stone-900 text-white text-4xl md:text-5xl font-black py-3 px-4 rounded-lg min-w-[80px]" data-id="element-93">
              {hours}
            </div>
            <span className="text-xs font-bold text-stone-500 mt-2 uppercase" data-id="element-94">
              Horas
            </span>
          </div>
          <div className="text-4xl md:text-5xl font-black text-stone-900 py-2" data-id="element-95">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-96">
            <div className="bg-stone-900 text-white text-4xl md:text-5xl font-black py-3 px-4 rounded-lg min-w-[80px]" data-id="element-97">
              {minutes}
            </div>
            <span className="text-xs font-bold text-stone-500 mt-2 uppercase" data-id="element-98">
              Min
            </span>
          </div>
          <div className="text-4xl md:text-5xl font-black text-stone-900 py-2" data-id="element-99">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-100">
            <div className="bg-stone-900 text-white text-4xl md:text-5xl font-black py-3 px-4 rounded-lg min-w-[80px]" data-id="element-101">
              {seconds}
            </div>
            <span className="text-xs font-bold text-stone-500 mt-2 uppercase" data-id="element-102">
              Seg
            </span>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 text-stone-600 font-medium mb-10" data-id="element-103">
          <AlertTriangle className="w-5 h-5 text-amber-500" data-id="element-104" />
          <p data-id="element-105">⚠️ Después sube. No vuelve.</p>
        </div>

        <div className="bg-stone-50 p-6 rounded-2xl border border-stone-200" data-id="element-106">
          <div className="flex justify-between items-end mb-2" data-id="element-107">
            <span className="font-bold text-stone-800" data-id="element-108">
              🔴 Cupos al precio de lanzamiento — Quedan pocos
            </span>
            <span className="font-bold text-brand-600" data-id="element-109">68%</span>
          </div>
          <div className="w-full bg-stone-200 rounded-full h-4 mb-2 overflow-hidden" data-id="element-110">
            <motion.div className="bg-red-500 h-4 rounded-full" initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} data-id="element-111" />
          </div>
          <p className="text-sm text-stone-500 text-left" data-id="element-112">
            68% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </section>;
}